const zh = {
  requirementList: '需求清单',
  material: '物控',
  purchase: '采购',
  prod: '生产',
  finance: '财务',
  sale: '业务',
  materialStatus: '物控审核状态',
  purchaseStatus: '采购审核状态',
  prodStatus: '生产审核状态',
  financeStatus: '财务审核状态',
  saleStatus: '业务审核状态',
  materialDesc: '物控审核备注',
  purchaseDesc: '采购审核备注',
  prodDesc: '生产审核备注',
  financeDesc: '财务审核备注',
  saleDesc: '业务审核备注',

  commodity: '产品',
  commodityStatus: '产品审核状态',
  commodityDesc: '产品审核备注',

  passed: '已通过',
  notPass: '未通过',
  approvalTip: '请输入审核备注',
  listSearchTip: '输入编号、描述、产品信息进行搜索',

  number: '编号',
  bomAmount: '用量',
  requireCount: '所需数量',
  itemCountInfo: '所需单品数',
  materialProgress: '物料准备进度',
  mrd: '要求齐料时间',
  plMrd: '请先填写要求齐料时间',
  mcPre: '物控备品量',
  bomData: '标准数量总数',
  estimatedCost: '预估花费',
  passStatus: '审批状态',

  errorTip: '错误提示',
  errorDesc: '表中存在数据异常，你确定不进行修改后提交吗？',
  noRepl: '暂无替代料可选',
  selectRepl: '选择替代料',
  allCount: '总数量已进行向上取整，您可以根据实际情况修改总使用量',

  matchBom: '匹配Bom表',
  editQuantity: '修改数量',
  matchInventory: '匹配库存',
  alrPreOutNum: '已预出库数量',
  preOut: '预出库',
  confirmPickOut: '本次预出库数量小于实际可出库数量时，以实际可出库数量为准进行生成领料单，是否生成预出库单？',
  prePickOut: '生成预出库单',
  prePickOutNum: '本次预出库数量',
  actualOutNum: '实际可出库数量',
  addDesc: '添加备注',
  done: '完成',
  doneSuccess: '成功生成需求清单',
  doneSuccessTip: '需求清单 {{ number }}已生成, 将由相关业务继续进行下一步操作',
  next: '下一步',
  previous: '上一步',
  requirementAdd: '生成需求清单',
  selectPro: '选择商品',
  searchPro: '输入产品关键字查询',

  detail: '需求清单详情',
  orderDetail: '订单详情',

  purCount: '需采购数量',
  purEdCount: '采购到货数量',
  preInCount: '预入库数量',
  preOutCount: '预出库数量',
  minPrice: '最低单价',
  maxPrice: '最高单价',
  minCost: '最低成本',
  maxCost: '最高成本',
  supplierAndPrice: '供应商与价格选择',
  addPurDesc: '添加采购描述',

  notApproved: '暂未审批',

  requirementAppInfo: '需求清单评审信息',
  eps: '预计上线日期',
  plEps: '请填写预计上线时间',
  saveTemp: '保存模板',
  saveTempSuccess: '模板添加成功',
  useQuantity: '单品使用数量',
  addConfirm: '你确定要添加这个需求单吗？',
  selectProdPro: '选择生产母件',
  plSelectProdPro: '请选择要生产的母件',
  product: '母件',
  prodCount: '生产数量',
  plProdCount: '请输入生产数量',
  desc: '需求清单备注',
  plDesc: '请输入需求清单备注',
  plSubPro: '选择子件信息',
  tempSuccess: '模板创建成功',
  validError: "校验错误",
  addRequirement: '添加需求清单',
  total: '总数',
  success: '成功',
  failed: '失败',
  exportExcel: '导出 Excel',
  requirementCreate: '生成需求清单',
  mainInfo: "主件信息",
  flow: "审批流",
  delSubTip: '你确定要删除选中子件吗？删除后无法进行恢复',
  syncClearRequirementItems: '同步清除需求单项',
  syncClearRequirementItemsTip: '你确定要删除当前需求清单下所有需求清单项吗？删除后无法进行恢复',
  delOrderItemTip: '是否删除对应的领料单？',
  delPurchaseOrderItemTip: '是否删除对应的采购单？',
  selectAll: '全选',
  oked: '已通过',
  pending: '待进行',
  rejected: "已拒绝",
  rejectTip: '你确定要拒绝这个需求清单吗? 拒绝后, 会返回业务上一步操作',
  rejectReason: '拒绝原因',
  rejectReasonRequired: '请输入拒绝原因',
  rejectReasonPlaceholder: '请详细说明拒绝的原因...',
  rejectReasonMaxLength: '拒绝原因不能超过500个字符',
  closeTip: '你确定要关闭这个需求清单吗? 关闭后, 数据将无法更改',
  supplier: "供应商",
  ert: '预计交货时间',
  supplierPriceNo: '暂无供应商价格可选',
  surOk: '添加采购单成功,请筛选页面查看',
  surSure: '请确认有可采购数据',
  reject: '拒绝',
  close: '关闭',
  saleNum: '销售数量',
  prNum: '生产数量',
  plPrNum: '请输入生产数量',
  orderAlready: '该订单已生成需求单',
  orderDate: "订单日期",
  pricePreview: '产品价格预览',
  endError: "你确定这个订单已经完成吗？",
  plSeSupplier: "选择供应商",
  plPlacePrice: "选择下单价格",
  noPurchaseTip: "暂无数据可用于采购",
  okPurchase: "确认购买",

  onKeyQutote: "一键问询",
  subQutote: "分批问询",
  onKeyPrice: "一键询价",
  subPrice: "分批询价",
  onKeyPurchese: "一键生成预采购单",
  sendQutote: "问询单已发送",
  sendQutotePro: "已发送{{len}}个项目的询价请求",
  ddl: "截止时间",
  noSupplier: "暂无可发送问询单的供应商",
  qutoteSednFail: "发送问询单失败",
  supplierProgress: "供应商反馈进度",
  unRead: "未读",
  read: "已读",
  unPriced: "待报价",
  resolved: "已报价",
  qutotationProgress: "询价单进度详情",
  matInfo: "物料信息",
  requirementInfo: "报价信息",
  requirementHelp: "协助报价",
  supplierQuote: "供应商报价",
  status: "状态",
  days: "供货周期",
  mpq: "最小包装",
  supplierTime: "齐料时间",
  edit: "编辑",
  resped: "已反馈",
  unResp: "未反馈",
  rulePrice: "合同价",
  ruleDays: "合同供货周期",
  ruleMpq: "合同最小包装",
  price: "价格",
  inputPrice: "请输入价格",
  priceTip: "提示: 报价比合同价要高, 可能会导致报价无效哦",
  inputDays: "请输入供货周期",
  daysTip: "提示: 供货周期大于合同供货周期, 可能会导致报价无效哦",
  mpqTip: "提示: 最小包装数大于合同最小包装数, 可能会导致报价无效哦",
  inputSuppTime: "请输入齐料时间",
  addSuppQutoteTip: "此供应商已有询价单，无需新增",
  addSuppQutote: "新增供应商报价",

  inputMpq: "请输入最小包装",
  ddlTime: "最晚交货时间",
  inputDdlTime: "请输入最晚交货时间",
  ddlTimeTip: "提示: 最晚交货时间超过了要求齐料时间, 超时可能会导致报价无效哦",
  prevDMrd: "预计交货时间",
  deadline: "最晚提交时间",

  nuRead: "未读",
  timedOut: "已逾期",
  day: "天",
  hour: "小时",
  purTip: "确定生成预采购单？",
  purContent: "这将自动生成预采购单",

  salePrice: "销售金额",
  mateCost: "物料成本",
  notCount: "未计算",
  netProfit: "净利润",
  goPur: "生成采购单",

  lazyQuota: '延时报价',
  lazyQuotaSuc: '延时报价成功',
  lazyQuotaErr: '延时报价失败',
  lazyTime: '选择或输入要延时的时间段',
  curLazy: '当前报价截止时间',

  notSelectTip: '以下物料不存在有效报价',
  purchaseProgress: "采购单进度",
  quotationProgress: "问询单发送进度",
  notSelect: '部分物料没有有效报价，请确保每个物料都存在有效报价后再进行通过',
  autoPurcheseSucc: "自动生成预采购单成功，部分物料没有有效报价无法生成预采购单",
  noQuotationTip: '标红物料不存在有效报价',
  searchPlaceHolder: '输入供应商或产品信息查询',
  allQuotation: '全部问询单',
  purchaseOrders: '采购订单',
  prePurchaseOrders: '预采购单',
  preview: '预览',
  toGen: '待生成',
  unApprove: '待审核',
  approved: '已审核',
  timed: '已过期',
  updatePrice: '修改报价',
  rePrice: '重新报价',
  quotation: '报价审批',
  reSelect: '手动选择',
  selected: '已选择',
  reSelecteDone: '已重新选择',
  reSelecteFail: '重新选择失败',
  createPreOutInventory: '生成领料出库单',
  createPreOutInventoryCon: '确定生成领料出库单?',
  createPreOutInventorySuccess: '生成预出库单成功',
  createPreOutInventoryFail: '生成预出库单失败',
  noPreOutInventory: '没有可出库物料',
  pleaseSelect: '请选择物料',
  preOutInventory: '预出库单',
  goodsName: '物料名称',
  availableQuantity: '可出库数量',
  inCount: '已入库数量',
  outCount: '已出库数量',
  shouldOutCount: '应发数量',
  actualOutCount: '实发数量',
  requirmentQuantity: '需采购数量',
  preReadyGood: '常备物料无需出库',
  outInventory: '出库单',

  notQuo: "无需报价",
  notPur: "无需采购",

  mrdEdit: "预计交货时间调整",
  quoEdit: "问询单修改",
  curMrd: "当前交货时间",
  selMrd: "选择最终交货时间",
  finalMrd: "最终交货时间",
  closeReq: "关闭需求单",
  editNum: "修改需求清单数量",

  plReqCount: "请输入所需数量",
  plPurCount: "请输入需采购数量",
  purCountErr: "需采购数量必须小于所需数量",
  bomAmountErr: "请输入有效的BOM用量",
  quantityAndBomAmount: "数量和用量不能为空或为 0",
  skipStock: "跳过匹配库存（不进行预出库）",
  overInventoryTip: "注意：标红数据代表预出库数量大于当前库存数量",
  skipMerge: "合并相同物料（相同的物料合并，数量相加）",
  finalPurQuantity: "最终采购数量",
  quotationTip: "报价后不可再进行修改，是否确定提交报价？",
  notAddCloseTip: "物料还未添加，是否确认关闭？",
  confirmAddProduct: "确认添加商品信息",
  duplicateMaterialTip: "标黄物料代表该物料存在另一个相同物料",
  matching: "正在匹配...",
  documentGenerationFailed: "文档生成失败",
  printFailed: "打印失败",
  pdfGenerationFailed: "生成PDF失败",
  requirementListAll: "需求清单_全部",
  exportMatchResult: "导出匹配结果",

  // MultiPurchaseSteps 批量采购下单
  multiPurchaseTitle: "批量采购下单",
  selectSupplier: "选择供应商",
  matchProduct: "匹配料号",
  matchPrice: "匹配价格",
  generatePurchase: "生成采购单",
  acceptPurchase: "接受采购单",
  complete: "完成",
  nextStep: "下一步",
  prevStep: "上一步",
  tip: "提示",
  enterGenerateTip: "进入生成采购步骤之后不可回退",
  confirmClose: "确定关闭？",
  closeTipContent: "采购单还未生成，确定关闭？",

  // MatchProduct 匹配料号
  oneClickAddProduct: "一键添加物料",
  addingProduct: "正在添加物料",
  processed: "已处理：",
  productsWithoutPrice: "标红物料是该供应商所在系统中不存在的物料，需要为该供应商系统添加此物料",
  noNeedAddProduct: "无需添加物料",
  noNeedAddProductDesc: "没有不存在的物料，无需添加",
  supplierApiError: "供应商Api异常，请检查",
  productMatchFailed: "物料匹配失败",
  productMatchFailedDesc: "供应商Api:",
  successAddProduct: "成功添加",
  productAddFailed: "个物料，失败",
  oneClickAddPrice: "一键添加价格",
  addingPrice: "正在添加价格",
  productsWithoutPriceTip: "标红物料是该供应商系统中不存在价格的物料，需要为该供应商系统添加此物料价格",
  noNeedAddPrice: "无需添加价格",
  allProductsHavePrice: "所有物料已有价格",
  supplierIdError: "供应商ID异常，请检查",
  successAddPrice: "成功添加",
  priceAddFailed: "个价格，失败",

  // GeneratePurchase 生成采购单
  oneClickOrder: "一键下单",
  ordering: "正在下单",
  successGeneratePurchase: "成功生成",
  purchaseOrder: "个采购单",
  generatePurchaseFailed: "个采购单，失败",
  purchaseOrderNumber: "采购单号",
  purchaseQuantity: "采购数量",
  orderStatus: "订单状态",
  ordered: "已下单",
  finished: "已完成",
  notOrdered: "未下单",
  acceptStatus: "接受状态",
  accepted: "已接受",
  oneClickAccept: "一键接受",
  accepting: "正在接受采购单",
  noData: "无数据",
  noPurchaseOrderToAccept: "没有需要接受的采购单",
  successAccept: "成功接受",
  acceptFailed: "个采购单，失败",
  noPurchaseDataTip: "无需采购和已生成预采购单的数据不进行采购下单",
  swapSale: "转单",
  // SwapSaleOrder 转单
  noDataToTransfer: "没有可以转单的数据",
  noDataToTransferDesc: "无需采购和已经生成预采购单的数据不进行转单",
  supplierApiLabel: "供应商Api：",
  fetchOrgInfoFailed: "获取组织信息失败",
  orgLabel: "组织：",
  selectSupplierAndCustomer: "请选择供应商组织和终端客户",
  noMatchedProductData: "没有匹配的产品数据",
  saleOrderTransferSuccess: "销售单转单成功",
  saleOrderNumber: "销售单号：",
  saleOrderGenerateFailed: "销售单生成失败",
  selectSupplierFirst: "请选择供应商",
  selectSupplierOrg: "请选择供应商组织",
  selectSupplierCustomer: "请选择供应商终端客户",
  confirmGenerateSaleOrder: "确定生成销售单么？",
  generateSaleOrderForSupplier: "给供应商：",
  swapEnd: "信息匹配失败，转单终止。",
  noCustomerPrice: "标红的物料在供应商系统中不存在此终端客户价格",
  plAddCustomerPrice: "请去供应商系统中添加该终端客户的物料价格",
  noProducts: "标红的物料在供应商系统中不存在",
  plAddProdictOne: "1、去供应商系统中添加这些物料信息",
  plAddProdictTwo: "2、去供应商系统中添加这些物料的商品价格",
  closeSaleOrderTip: "是否删除关联的销售单：",
  plAddSupplierPrice: '标红物料不存在该供应商价格，请先维护本系统这些物料的供应商价格',
  batchSelect: '批量选中问询单',
  progress: '进度',
  importQuotationExcel: '导入报价Excel',
  quotationImportPreview: '供应商报价导入预览',
  quotationImportRowNumber: '行号',
  quotationImportRequirementItemId: '需求项ID',
  quotationImportSupplierCode: '供应商编码',
  quotationImportSupplierName: '供应商名称',
  quotationImportPrice: '价格',
  quotationImportMpq: '最小包',
  quotationImportStatus: '状态',
  quotationImportItemIdRequired: '需求项ID不能为空',
  quotationImportItemNotFound: '需求项ID不存在或已失效',
  quotationImportProductMismatch: '需求项ID与存货编码不匹配',
  quotationImportSupplierRequired: '供应商编码不能为空',
  quotationImportSupplierLoadFailed: '供应商数据加载失败',
  quotationImportPriceInvalid: '价格必须是大于0的有效数字',
  quotationImportMpqInvalid: '最小包必须是大于0的有效数字',
  quotationImportNoMrd: '需求单未设置MRD，无法确定最晚交货期',
  quotationImportInvalidHeader: '导入文件表头不正确，请使用当前详情导出的文件',
  quotationImportFileEmpty: '导入文件没有可处理的数据',
  quotationImportParseFailed: '导入文件解析失败',
  quotationImportSubmitFailed: '供应商报价新增失败',
  quotationImportReady: '可提交',
  quotationImportReselect: '重新选择文件',
  quotationImportHasErrors: '存在校验错误，请修正Excel后重新导入',
  quotationImportSummary: '成功 {{success}} 条，失败 {{failed}} 条',
  salePass: "转为正式订单",
  downloadTemplate: "下载模版",
  inputTemp: "从模版录入",
  importTemplate: "需求清单导入模版",
  invalidTemplate: "请选择正确的模版文件",
  parseDataSuccess: "成功解析 {{count}} 条数据",
  atLeastOnePreOutGreaterThanZero: "至少一个预出库大于0",
  cusOrderQty: "客户订单数量",
  cusOrderQtyTip: "转单订单",
  processFilter: "搜索物料制程",
  delErrTip: "以下物料存在已出库数量，不可删除！",
  mixReplaced: "组合使用替代料",
  preOutDesc: "预出库备注",
  prePickOutLimitAutoTip: "本次预出库数量已自动限制在合法范围内",
  prePickOutRemainLimit: "剩余可预出库数量",
  prePickOutStockLimit: "可用库存数量",
  prePickOutMaxLimit: "最大可填数量",
  deductOutCount: "扣减已出库数量",
  inOrderDesc: "送货单备注",
  plInventoryDesc: "请输入送货单备注",
  noSale: "没有源销售单，不可转单",
  overTip: "商品的使用库存数量总数超出商品可用库存数量",
  oldApprove: "原审批顺序",
  newApprove: "新审批顺序",
  approveSaveTip: "本次通过问询单将同时保存新的审批顺序",
  approveRemark: "审核备注",
  matchFactory: "匹配产线仓库",
  matchLocType: "库存匹配库位类型",
  rematch: "匹配库存",
  rematchTip: "匹配库存库位类型已修改，请重新匹配库存",
  priceFloor: "采购单价格取整",
  needReturn: "部分出库单已确认出库！",
  needReturnTip: "包含以下物料的领料单需要退库",
  bomDatax: "系统BOM数据",
  templeData: "模版",
  xlsData: "销售单BOM文件",
  dataTypeTip: "选择匹配BOM数据源",
  dataTypeErr: "该销售单BOM表数据解析异常",
  dataTypeErrTip: "请检查该销售单BOM表数据，或切换其他匹配BOM数据源",
  pickErr: "新的预出库单：{{number}}库存分配失败，是否保留？",
  pickErrTip: "预出库单：{{number}}，生成成功",
  pickErrContent: "请在仓储管理分配库存",
  pickErrDel: "生成预出库单失败",
  itemDesc: "物料备注",
  preOutErrTip: "需求清单{{number}}生成成功，预出库单生成失败，请重试！",
  rePreOutAdd: "重试预出库",
  failPreTip: "需求单预出库单生成失败！",
  failPreTipDesc: "预出库单生成失败将导致需求单数量错误！如果不处理预出库单失败，建议删掉本需求单重新跑！",
};

export default zh;
